// removed by extract-text-webpack-plugin
module.exports = {"login":"Login__login___3M993","wrapper":"Login__wrapper___3jdvg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Login/Login.css
// module id = 931
// module chunks = 0